<template>
  <header>
  <!-- header to mobile and tablet -->
  <div v-if="$mq === 'mobile' || $mq === 'tablet'" ref="headerMobile" :style="{backgroundColor: getCssColor('bg_header'), top: marginTop + 'px' }" class="header">
    <b-container fluid style="margin-top:20px;line-height:70px;">
      <b-row>
        <b-col cols="2">
          <a @click="menuLinksModal = true" aria-label="Menu" style="text-align:left;cursor:pointer;" class="ico" :style="{color: getCssColor('header_icon_color')}"><font-awesome-icon :icon="['fal', 'bars']"/></a>
        </b-col>
        <b-col cols="2" style="text-align:left;">
          <a @click="search()" class="ico" :style="{color: getCssColor('header_icon_color')}"><font-awesome-icon :icon="['fal', 'search']"/></a>
        </b-col>
        <b-col cols="4" style="text-align:center;">
          <!--img :src="getImgPath + '/logo/logo_bombay.svg'" class="logo" /-->
          <img @click="$router.push({path:'/home'})" :src="logo" alt="logo" class="logo" />
        </b-col>
        <b-col cols="2" style="text-align:right;">
          <a @click="checkLogin()" class="ico" :style="{color: getCssColor('header_icon_color')}"><font-awesome-icon :icon="['fal', 'user']"/></a>
        </b-col>
        <b-col cols="2" style="position:relative;">
          <a href="#/cart" aria-label="Cart" style="position:relative;" class="ico" :style="{color: getCssColor('header_icon_color')}">
            <CartBullet/>
            <font-awesome-icon :icon="['fal', 'shopping-cart']"/>
          </a>
        </b-col>
        <template v-if="$store.state.company.block_address_navigation && $store.state.company.block_address_navigation !== 'NO'">
          <b-col cols="12"  style="height:24px;line-height:20px;color:#ffffff;margin-top:-8px;position:relative;" :style="{backgroundColor: getCssColor('primary_bt') }">
            <div @click="clearSelectedAddress()" style="cursor:pointer;">
              <font-awesome-icon :icon="['fal', 'home']" style="font-size:18px;cursor:pointer;margin-top:2px;"/> {{$store.state.selectedAddressShort}} <font-awesome-icon :icon="['fal', 'angle-down']" style="font-size:20px;cursor:pointer;margin-left:10px;"/>
            </div>
            <!-- alert pre choice address -->
            <div v-if="$store.state.addressAlertModal" class="alert_address_modal">
              <p>
                <font-awesome-icon :icon="['fas', 'caret-up']" style="font-size:24px;margin-right:10px;"/>
                Endereço de Entrega Selecionado
              </p>
              <p>
                Deseja trocar o endereço?
              </p>
              <p>
                <button @click="$store.state.addressAlertModal=false; $forceUpdate()" style="height:30px;border:1px #b24a4a solid;border-radius:6px;color:#b24a4a;font-size:16px;background-color:#ffffff;margin:0 10px;padding:0 10px;">NÃO</button><button @click="clearSelectedAddress()" style="height:30px;border:1px #77874b solid;border-radius:6px;color:#77874b;font-size:18px;background-color:#ffffff;margin:0 10px;padding:0 10px;">SIM</button>
              </p>
            </div>
            <!-- -->
          </b-col>
        </template>
      </b-row>
    </b-container>
    <div v-if="showFloatCart" class="shadow"  @click="gotToPath('/cart')" style="background-color:#ffffff;cursor:pointer;z-index:12000;position:fixed;width:60px;height:60px;border:2px solid;border-radius:32px;bottom:20px;right:20px;text-align:center;line-height:60px;" :style="{color: getCssColor('primary_bt'), borderColor: getCssColor('primary_bt')}">
      <CartBullet style="top:2px;right:2px;"/>
      <font-awesome-icon style="font-size:28px;margin-right:3px;margin-top:17px;" :icon="['fal', 'shopping-cart']"/>
    </div>

    <!-- TODO component -->
    <!-- menu modal -->
    <div :class="{menuLinksModalOpenned:menuLinksModal, menuLinksModal:!menuLinksModal}" style="position:fixed;top:0px;z-index:21000;background-color:#ffffff;">
      <b-container>
        <b-row class="headerBackCart" style="height:60px;" :style="{backgroundColor: getCssColor('bg_header')}">
          <b-col cols="2" style="height:60px;line-height:60px;text-align:center;">
            <div @click="menuLinksModal=false" style="cursor:pointer;" :style="{color: getCssColor('primary_bt')}">
              <font-awesome-icon style="font-size:20px;"  :icon="['fal', 'chevron-left']"/>
            </div>
          </b-col>
          <b-col cols="10" style="height:60px;line-height:54px;font-weight:500;font-size: 18px; color: #757F8C;">
            MENU
          </b-col>
        </b-row>
        <b-row>
          <MenuLinks />
        </b-row>
      </b-container>
    </div>

  </div>
  <!-- header to desktop -->
  <div v-else class="headerDesk" :style="{backgroundColor: getCssColor('bg_header')}">
    <b-container @mouseover="showCategoriesModal=false;" style="height:117px;line-height:117px">
      <b-row>
        <b-col cols="3">
          <!--img :src="getImgPath + '/logo/logo_bombay.svg'" class="logodesk" /-->
          <img @click="$router.push({path:'/home'})" :src="logo" alt="logo" class="logodesk" />
        </b-col>
        <template v-if="$store.state.company.block_address_navigation && $store.state.company.block_address_navigation !== 'NO'">
          <b-col cols="2"  style="text-overflow: ellipsis;white-space: nowrap;overflow: hidden;padding-right:0px;margin-right:0px;position:relative;">
            <div @click="clearSelectedAddress()">
              <font-awesome-icon :icon="['fal', 'home']" style="font-size:24px;cursor:pointer;"/> {{$store.state.selectedAddressShort}} 
            </div>
            <!-- alert pre choice address -->
            <div v-if="$store.state.addressAlertModal" style="z-index:21000;top:100px;position:fixed;line-height:20px;" class="alert_address_modal" :style="{borderColor: getCssColor('primary_bt')}">
              <p>
                <font-awesome-icon :icon="['fas', 'caret-up']" style="font-size:24px;margin-right:10px;"/>
                Endereço de Entrega Selecionado
              </p>
              <p>
                Deseja trocar o endereço?
              </p>
              <p>
               <button @click="$store.state.addressAlertModal=false; $forceUpdate()" style="height:30px;border:1px #b24a4a solid;border-radius:6px;color:#b24a4a;font-size:16px;background-color:#ffffff;margin:0 10px;padding:0 10px;">NÃO</button><button @click="clearSelectedAddress()" style="height:30px;border:1px #77874b solid;border-radius:6px;color:#77874b;font-size:18px;background-color:#ffffff;margin:0 10px;padding:0 10px;">SIM</button>
              </p>
            </div>
            <!-- -->
          </b-col>
          <b-col cols="1" @click="clearSelectedAddress()">
            <font-awesome-icon :icon="['fal', 'chevron-down']" style="font-size:24px;cursor:pointer;"/>
          </b-col>
          <b-col cols="4" style="text-align:center;">
            <input type="text" ref="searchBox2" @keyup="search()" v-model="$store.state.searchTerm" class="inputText search" placeholder="Digite o que você procura" style="width:calc( 100% - 30px);height:40px;"/>
            <font-awesome-icon :icon="['fal', 'search']" style="position:relative; right: 40px;top:3px;font-size:24px;cursor:pointer;"/>
          </b-col>
        </template>
        <template v-else>
          <b-col cols="7" style="text-align:center;">
            <input type="text" ref="searchBox2" @keyup="search()" v-model="$store.state.searchTerm" class="inputText search" placeholder="Digite o que você procura" style="width:calc( 100% - 30px);height:40px;"/>
            <font-awesome-icon :icon="['fal', 'search']" style="position:relative; right: 40px;top:3px;font-size:24px;cursor:pointer;"/>
          </b-col>
        </template>
        <b-col cols="1" style="text-align:right;">
          <a style="cursor:pointer;" @click="checkLogin()" class="ico" :style="{color: getCssColor('header_icon_color')}"><font-awesome-icon :icon="['fal', 'user']"/></a>
        </b-col>
        <b-col cols="1" style="text-align:center;">
          <a href="#/cart" aria-label="Cart" class="ico" style="position:relative;" :style="{color: getCssColor('header_icon_color')}">
            <CartBullet/>
            <font-awesome-icon :icon="['fal', 'shopping-cart']"/>
          </a>
        </b-col>
      </b-row>
    </b-container>
    <b-container fluid style="height:63px;" :style="{backgroundColor: getCssColor('bg_subheader')}">
      <b-row>
        <b-col class="subheader" :style="{color: getCssColor('font_subheader_color')}">
          <!-- span @click="$router.push({path:'/categories/0'})" style="margin: 0px 15px; cursor:pointer;" @mouseover="showCategoriesModal=false;">Produtos</span -->
          <span ref="products" style="margin: 0px 15px; cursor:pointer;" @click="showCategoriesModal=true" >Categorias</span>
          <span
            v-if="$store.state.company.block_address_navigation && $store.state.company.block_address_navigation === 'YES_LIST'"
            @click="$router.push({path:'/company_list/' + $store.state.lastLatLongUri})" style="margin: 0px 15px; cursor:pointer;" @mouseover="showCategoriesModal=false;">Ver Todas as Lojas</span>
          <span v-if="$store.state.activateOffers" @click="$router.push({path:'/offers'})" style="margin: 0px 15px; cursor:pointer;" @mouseover="showCategoriesModal=false;">Ativar Ofertas</span>
          <span @click="$router.push({path:'/history'})" style="margin: 0px 15px; cursor:pointer;" @mouseover="showCategoriesModal=false;">Minhas Compras</span>
          <span @click="$router.push({path:'/map'})" style="margin: 0px 15px; cursor:pointer;" @mouseover="showCategoriesModal=false;">Área de Entrega</span>
          <span @click="$router.push({path:'/contact'})" style="margin: 0px 15px; cursor:pointer;" @mouseover="showCategoriesModal=false;">Contato</span>
        </b-col>
      </b-row>
    </b-container>
    <CategoriesModal v-show="showCategoriesModal===true" to="products" @mouseover.native="showCategoriesModal=true" @mouseleave.native="showCategoriesModal=false;" />
    <div class="shadow"  @click="gotToPath('/cart')" style="background-color:#ffffff;cursor:pointer;z-index:12000;position:fixed;width:70px;height:70px;border:2px solid;border-radius:37px;bottom:30px;right:30px;text-align:center;line-height:70px;" :style="{color: getCssColor('primary_bt'), borderColor: getCssColor('primary_bt')}">
      <CartBullet style="top:3px;right:3px;" />
      <font-awesome-icon style="font-size:32px;margin-right:5px;margin-top:18px;" :icon="['fal', 'shopping-cart']"/>
    </div>
  </div>

  <!-- SearchBox v-model="searchBoxModal" @closeSearch="() => searchBoxModal = false"/ -->

  <!-- address modal -->
    <OpaSlideModal 
      v-if="this.$store.state.user && this.$store.state.user.adresses.length" 
      title="Escolher Endereço" 
      direction="down"
      v-model="addressModal"
      @slideModalClose="() => addressModal = false"
      >
      <b-row style="overflow-y:auto; overflow-x:none; height:calc(100vh - 176px);">
        <b-col>
          <AddressList @selectedAddress="(addressId) => selectAddress(addressId)" />
        </b-col>
      </b-row>
      <b-row style="position:absolute;bottom:0px;height:120px;background-color:rgb(250, 250, 250);width:100%">
        <b-col>
          <b-row style="margin-top:10px;">
            <b-col style="text-align:center;">
              <button
                :style="{color: getCssColor('primary_bt'),
                borderColor: getCssColor('primary_bt')}"
                class="button_storeheader_wire"
                @click="newAddress()"
                  >NOVO ENDEREÇO</button>
            </b-col>
          </b-row>
          <b-row  style="margin-top:10px;">
            <b-col  style="text-align:center;">
              <button
                class="button_storeheader_solid"
                @click="verifyBlock()"
                :style="{backgroundColor: getCssColor('primary_bt')}"
                  >CONTINUAR</button>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </OpaSlideModal>
  </header>
  
</template>

<script>
import navigation from '@/mixins/navigation'
import { mapGetters } from 'vuex'
import { EventBus } from '@/behaviours/event-bus'
import colors from '@/mixins/colors'
import CategoriesModal from '@/components/CategoriesModal.vue'
import CartBullet from '@/components/CartBullet.vue'
import UserConn from '@/connection/user'
import MenuLinks from '@/components/MenuLinks'
import OpaSlideModal from '@/components/OpaSlideModal'
import AddressList from '@/components/AddressList'
//import SearchBox from '@/components/SearchBox'

export default {
  name: 'StoreHeader',

  data () {
    return {
      marginTop: -20,
      headerHeight: 95,
      showCategoriesModal: false,
      showFloatCart: false,
      menuLinksModal: false,
      addressModal: false,
      selectedId: null,
      initAddressModal: false//,
      //searchBoxModal: false
    }
  },

  components: {CategoriesModal, CartBullet, MenuLinks, OpaSlideModal, AddressList},

  mixins: [colors, navigation],

  computed: {
    ...mapGetters([
      'getImgPath'
    ]),

    logo () {
      return this.$store.getters.getLogo
    },

    shortName () {
      return this.$store.getters.getShortName
    }
  },

  methods: {
    checkLogin () {
      if (UserConn.isLoggedIn()) {
        // to my data
        this.$router.push({path: '/profile'})
      } else {
        // to login
        this.$router.push({path: '/login'})
      }
    },

    search () {
      this.$store.state.activeSearch = true
      // if (this.$route.name !== 'categories') {
      //   this.$router.push({path: '/categories/0'})
      // }
      //this.searchBoxModal = true
      this.$router.push({path:'/search'})
    },

    clearSelectedAddress () {
      this.$store.state.addressAlertModal=false
      console.log('clearSelectedAddress', this.$store.state.user)
      if (this.$store.state.user) {
        this.addressModal = true
        this.initAddressModal = true
      } else {
        location.reload()
      }
    },

    async selectAddress(addressId) {
      console.log('SELECT ADDR HOME')
      this.selectedId = addressId
      // add the selected ID to session for use in checkout
      this.$store.state.selectedAddressId = addressId
      if (this.initAddressModal) {
        let addr = this.$store.state.user.adresses.filter(addr => addr.id === addressId)[0]
        // addr short name to selects
        this.$store.state.selectedAddressShort = addr.shortName
        //
        this.$store.state.lastLatLongUri = addr.latLong.lat + '/' + addr.latLong.lng
        this.$router.push({path: '/company_list/' + addr.latLong.lat + '/' + addr.latLong.lng})
      }
    },

    async verifyBlock () {
      this.selectAddress(this.selectedId)
    },

    newAddress () {
      this.$store.state.newAddressOrigin = "company_list"
      this.$router.push({path:'/address'})
    },
  },

  mounted () {

    if (this.$refs.searchBox2) {
      console.log('mount header2')
      this.$refs.searchBox2.focus()
    }

    // if (this.$router.currentRoute.path === '/home' || this.$router.currentRoute.path === '/categories') {
    //   this.searchBoxModal = this.$store.state.activeSearch
    // }

    console.log('mounted header')
    // all $on need to have an off on destroy
    EventBus.$on('srcollY', (data) => {
      // if header mobile
      if( (this.$mq === 'mobile' || this.$mq === 'tablet') && this.$refs['headerMobile']) {
        let oldY = data.oldY
        let newY = data.newY
        let topN = Number(this.$refs['headerMobile'].style.top.replace('px', ''))
        let calc = topN + ((oldY - newY)/4)
        if (calc > this.marginTop) {
          calc = this.marginTop
        } else if (calc < (Math.abs(this.marginTop) + this.headerHeight) * -1) {
          calc = (Math.abs(this.marginTop) + this.headerHeight) * -1
        }
        if (calc < (this.marginTop * 2)) {
          this.showFloatCart = true
        } else {
          this.showFloatCart = false
        }
        this.$refs['headerMobile'].style.top = calc + 'px'
      }
    })
  },

  destroyed () {
    console.log('destroy header')
    EventBus.$off('srcollY')
  }

  
}
</script>


<style lang="scss" scoped>

@import "@/css/_variables.scss";

.header {
  z-index:12000;
  position: fixed;
  height: 85px;
  left:0px;
  width: 100%;
  // max-width:1330;
  -webkit-box-shadow:0 1px 3px rgba(0, 0, 0, 0.2);
  -moz-box-shadow:0 1px 3px rgba(0, 0, 0, 0.2);
  box-shadow:0 1px 3px rgba(0, 0, 0, 0.2);
}


.ico {
  font-size: 24px;
}

.logo {
  max-width: 100px;//calc(100vw - 285px);
  max-height:60px;
  margin-top: auto;
  vertical-align:middle;
}

.logodesk {
  max-width:calc(100vw - 220px);
  max-height:63px;
  vertical-align:middle;
  margin-left:20px;
  cursor:pointer;
}

.headerDesk {
  height:180px;
  width:100vw;
  // max-width:1330px;
}

.subheader {
  font-size: 18px;
  font-weight:500;
  line-height:63px;
  text-align:center;
}


.menuLinksModal {
    height: 100vh;
    width: 100vw;
    left:-100vw;
    -webkit-transition: left 0.2s linear;
       -moz-transition: left 0.2s linear;
        -ms-transition: left 0.2s linear;
         -o-transition: left 0.2s linear;
            transition: left 0.2s linear;
}

.menuLinksModalOpenned{
  height: 100vh;
  width:100vw;
  left:0vw;
  -webkit-transition: left 0.2s linear;
    -moz-transition: left 0.2s linear;
      -ms-transition: left 0.2s linear;
      -o-transition: left 0.2s linear;
          transition: left 0.2s linear;
}


.button_storeheader_solid {
  height:44px;
  width:350px;
  border-radius:6px;
  color:#ffffff;
  font-size:14px;
  border: 0px;
  font-weight: 500;
  @media screen and (max-width: $tablet_max) {
    height:44px;
    width:100%;
    max-width:204px;
    font-size:14px;
  }
}

.button_storeheader_wire {
  height:44px;
  width:350px;
  border-radius:6px;
  font-size:14px;
  border: 1px solid;
  font-weight: 500;
  background-color:#ffffff;
  @media screen and (max-width: $tablet_max) {
    height:44px;
    width:100%;
    max-width:204px;
    font-size:14px;
  }
}

.alert_address_modal {
  text-align:center;
  position:absolute;
  width:300px;
  height:140px;
  background-color:#ffffff;
  color:#444;
  padding:10px;
  border-radius:6px;
  box-shadow: 2px 2px 3px rgba(0, 0, 0, 0.4);
  
}
</style>
